import { IAppProviderState } from '../interfaces/IAppProviderState';
import * as ActionKeys from './ActionKeys';
import { defaultState } from './InitialState';

export interface IStateReducer {
  type: string;
  payload: any;
}

export const reducer = (state: IAppProviderState, action: IStateReducer): IAppProviderState => {
  switch (action.type) {
    case ActionKeys.RELOAD_STATE:
      return {
        ...state,
        ...action.payload
      };
    case ActionKeys.SET_STATUSINITIAL:
      return {
        ...state,
        statusInitial: action.payload
      };
    case ActionKeys.SET_STATE_CHANGE:
      return {
        ...state,
        stateChange: action.payload
      };
    case ActionKeys.SET_LABELS:
      return {
        ...state,
        labels: action.payload
      };
    case ActionKeys.SET_LOADING_COMPLETE:
      return {
        ...state,
        isLoadingComplete: action.payload
      };
    case ActionKeys.SET_OCCUPATION:
      return {
        ...state,
        occupation: action.payload
      };
    case ActionKeys.SET_OCCUPATIONS:
      return {
        ...state,
        occupations: action.payload
      };
    case ActionKeys.SET_SPORTS:
      return {
        ...state,
        sports: action.payload
      };
    case ActionKeys.SET_CPR:
      return {
        ...state,
        cpr: action.payload
      };
    case ActionKeys.SET_PERMANENT_INJURY:
      return {
        ...state,
        permanentInjury: action.payload
      };
    case ActionKeys.SET_HAS_ERROR:
      return {
        ...state,
        hasError: action.payload,
        errorCode: 500
      };
    case ActionKeys.SET_RESET_ERROR:
      return {
        ...state,
        hasError: {
          stepOne: false,
          stepTwo: false
        },
        errorCode: 0
      };
    case ActionKeys.SET_PHONENO:
      return {
        ...state,
        phoneNo: action.payload
      };
    case ActionKeys.SET_NAME:
      return {
        ...state,
        name: action.payload
      };
    case ActionKeys.SET_PERSONAL_INFO: {
      return {
        ...state,
        personalInformation: {
          ...state.personalInformation,
          [action.payload.property]: action.payload.data
        }
      };
    }
    case ActionKeys.SET_STAKEHOLDER: {
      let p = state.personalInformation;
      p.name = action.payload.name;
      p.customerId = action.payload.customerId;
      p.address = action.payload.address;
      if (!state.personalInformation.phone || state.personalInformation.phone.status === 'invalid') {
        p.phone = action.payload.phone;
      }
      if (!state.personalInformation.email || state.personalInformation.email.status === 'invalid') {
        p.email = action.payload.email;
      }
      return {
        ...state,
        personalInformation: p,
        cpr: action.payload.cpr
      };
    }
    case ActionKeys.SET_PAYMENT: {
      return {
        ...state,
        payment: {
          ...state.payment,
          [action.payload.property]: action.payload.data
        }
      };
    }
    case ActionKeys.SET_PAYMENT_PERIOD: {
      return {
        ...state,
        paymentPeriod: action.payload
      };
    }
    case ActionKeys.SET_CONSENT: {
      return {
        ...state,
        paymentConsents: {
          ...state.paymentConsents,
          [action.payload.property]: action.payload.value
        }
      };
    }
    case ActionKeys.SET_CONTENT_BLOCK: {
      return {
        ...state,
        contentBlocks: { ...state.contentBlocks, ...action.payload }
      };
    }
    case ActionKeys.SET_COVERAGE_ITEMS:
      return {
        ...state,
        coverageItems: action.payload
      };
    case ActionKeys.SET_PACKAGE_DETAILS: {
      return {
        ...state,
        packagesDetails: action.payload
      };
    }
    case ActionKeys.SET_PACKAGES: {
      return {
        ...state,
        packages: action.payload
      };
    }
    case ActionKeys.SET_ADDITIONAL_COVERAGES: {
      return {
        ...state,
        selectedAdditionalCoverages: action.payload
      };
    }
    case ActionKeys.SET_SELECTED_MODIFIED_PACKAGE: {
      return {
        ...state,
        selectedModifiedPackage: action.payload
      };
    }
    case ActionKeys.SET_PACKAGE_MODIFIED_DETAILS: {
      return {
        ...state,
        modifiedPackageDetails: action.payload
      };
    }
    case ActionKeys.SET_COVERAGE_MODIFIED_DETAILS: {
      return {
        ...state,
        modifiedCoverageDetails: action.payload
      };
    }
    case ActionKeys.SET_TERMINATION: {
      return {
        ...state,
        termination: {
          ...state.termination,
          [action.payload.property]: action.payload.value
        }
      };
    }
    case ActionKeys.SET_RMO_REASON: {
      return {
        ...state,
        rmoReason: action.payload
      };
    }
    case ActionKeys.SET_BANNER_TEXTS:
      return {
        ...state,
        bannerHeader: action.payload.header,
        bannerText: action.payload.text,
        overlayText: action.payload.overlayText
      };
    case ActionKeys.SET_SHOW_BANNER_OVERLAY: {
      return {
        ...state,
        showBannerOverlay: action.payload
      };
    }
    case ActionKeys.SET_PACKAGE_INDEX: {
      return {
        ...state,
        selectedPackageIndex: action.payload
      };
    }
    case ActionKeys.SET_PROGRESS: {
      return {
        ...state,
        actualStep: action.payload,
        previousStep: state.actualStep
      };
    }
    case ActionKeys.SET_BASKET_ACCEPTED: {
      return {
        ...state,
        basketAccepted: action.payload
      };
    }
    case ActionKeys.SET_RESET: {
      return {
        ...state,
        ...defaultState
      };
    }
    case ActionKeys.SET_IS_PACKAGE_SUBMITTED: {
      return {
        ...state,
        isPackageSubmitted: action.payload
      };
    }
    case ActionKeys.SET_IS_PACKAGE_PRICE_LOADING: {
      return {
        ...state,
        isPackagePriceLoading: action.payload
      };
    }
    case ActionKeys.SET_PREV_ROUTE_CONFIG: {
      return {
        ...state,
        prevLocation: action.payload
      };
    }
    case ActionKeys.SET_ECOMMERCE_PRODUCT: {
      return {
        ...state,
        ecommerceProduct: action.payload
      };
    }
    case ActionKeys.SET_EBOKS_SUBSCRIPTION: {
      return {
        ...state,
        hasEboksSubscription: action.payload
      };
    }
    case ActionKeys.SET_LOADING_OBJECT_CACHE: {
      return {
        ...state,
        loadingObjectCache: action.payload
      };
    }
    case ActionKeys.SET_GIFT_CARD: {
      return {
        ...state,
        giftCard: action.payload
      };
    }
    case ActionKeys.SET_FLOW: {
      return {
        ...state,
        flow: action.payload
      };
    }
    case ActionKeys.SET_IS_USER_CHECKED: {
      return {
        ...state,
        isUserChecked: action.payload
      };
    }
    default:
      return state;
  }
};
